<template>
  <div id="problemList">
    <h1 class="mt-4" style="margin-bottom: 40px">Problems</h1>
    <b-container>
      <div id="new">
        <b-button
          v-if="userinfo.isAdmin && userinfo.isActive"
          variant="primary"
          to="/problem/add"
          style="margin-bottom: 40px"
          >New Problem</b-button
        >
      </div>
      <b-form class="text-left" style="margin-bottom: 20px; text-align: right">
        <b-input-group size="" class="mb-2">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            type="search"
            v-model="filter"
            placeholder="Search Problem"
          ></b-form-input>
        </b-input-group>
      </b-form>
      <b-table
        :fields="fields"
        :items="items"
        hover
        outlined
        :sort-by.sync="sortBy"
        :filter="filter"
        style="text-align: center"
      >
        <template #cell(action)="data">
          <!--
          <b-button size="sm" variant="primary" :href="`#/problem/${data.item.id}`">{{ data.value }}</b-button>
          -->
          
          <b-button size="sm" variant="primary" @click="toProblem(data.item.id)"
            >View</b-button
          >
          <b-dropdown v-if="userinfo.isAdmin"  size="sm" id="dropdown-admin" text="Admin" variant="primary" class="m-md-2">
            <b-dropdown-item @click="editProblem(data.item.id)">Edit Problem</b-dropdown-item>
            <b-dropdown-item @click="editCheckpoint(data.item.id)">Edit Checkpoint</b-dropdown-item>
            <b-dropdown-item @click="
              problem_title = data.item.title;
              problem_id = data.item.id;
              checkDeleteProbelm(items.indexOf(data.item));
            ">Delete</b-dropdown-item>
            <b-dropdown-item @click="get_project_url(data.item.id)">Goto GitLab</b-dropdown-item>
          </b-dropdown>
         
        </template>
      </b-table>
      <b-modal ref="warning" id="warning" hide-footer title="Warning">
        <div class="text-center" style="font-size: 1.2rem">
          <p>
            This action will delete problem "{{ problem_title }}" and all
            checkpoints of this problem!
          </p>
          <p>Are You Sure?</p>
        </div>
        <div class="col text-center">
          <b-button class="mt-3" variant="primary" @click="hideWarning"
            >No!</b-button
          >
          <b-button
            class="mt-3"
            variant="danger"
            @click="deleteProblem(problem_id)"
            style="margin-left: 10px"
            >Delete!</b-button
          >
        </div>
      </b-modal>
      <b-modal
        ref="errorModal"
        id="errorModal"
        hide-footer
        title="Project Error"
      >
        <div class="text-center" style="font-size: 1.2rem">
          <p>Please check this problem's config.</p>
          <p>Status Code: {{ status_code }}</p>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
export default {
  created() {
    this.get_user_info();
    this.getProblems();
  },
  beforeMount() {
    let self = this;
    this.$bus.$on("isAdmin", (event) => {
      self.is_admin = event.is_admin;
    });
  },
  mounted() {},
  beforeDestroy() {
    this.$bus.$off("isAdmin");
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "Problem ID",
          sortable: false,
          tdClass: 'align-middle'
        },
        {
          key: "title",
          tdClass: 'align-middle'
        },
        {
          key: "score_end_date",
          label: "Deadline",
          tdClass: 'align-middle'
        },
        {
          key: "score",
          label: "Score",
          tdClass: 'align-middle'
        },
        {
          key: "action",
          label: "Action",
          tdClass: 'align-middle'
        },
      ],
      items: [],
      sortBy: "id",
      is_admin: undefined,
      probelm_id: undefined,
      problem_title: "",
      origin_problems_num: 0,
      userinfo: {
        isAdmin: false,
        isActive: false,
      },
      filter: "",
      status_code: 0,
      score_list: [],
    };
  },
  methods: {
    getProblems() {
      let self = this;
      const api = "/problem/";
      const access_token = localStorage.getItem("access_token");
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          for (let i in response.data) {
            response.data[i].score_end_date = response.data[
              i
            ].score_end_date.replace(/T/, " ");
            response.data[i]["score"] = 0;
          }
          self.items = response.data;
          self.origin_problems_num = response.data.length;
          self.getProblemScore();
        });
      
    },
    getProblemScore() {
      let access_token = localStorage.getItem("access_token");
      let self = this;
      let score = 0;
      this.items.forEach(function(problem, index){
        self.$http
        .get("/problem/" +problem.id +"/score", {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          score = response.data;
          if (score != null)
            self.items[index]["score"] = score;
          else
            self.items[index]["score"] = 0;
        });
        
      });
      
    },
    toProblem(problem_id) {
      let self = this;
      this.$router.push({
        name: "Problem",
        params: {
          id: problem_id,
          userinfo: self.userinfo,
        },
      });
    },
    editProblem(problem_id) {
      let self = this;
      this.$router.push({
        name: "EditProblem",
        params: {
          id: problem_id,
          userinfo: self.userinfo,
        },
      });
    },
    editCheckpoint(problem_id) {
      let self = this;
      this.$router.push({
        name: "EditCheckpoint",
        params: {
          id: problem_id,
          userinfo: self.userinfo,
        },
      });
    },
    checkDeleteProbelm(index) {
      let self = this;
      if (index < this.origin_problems_num) {
        self.$refs["warning"].show();
      } else {
        self.items.splice(index, 1);
      }
    },
    deleteProblem(id) {
      let self = this;
      const api = "/problem/";
      const access_token = localStorage.getItem("access_token");

      this.$http
        .delete(api + id, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          if (response != undefined) {
            self.getProblems();
            self.$refs["warning"].hide();
          }
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    hideWarning() {
      this.$refs["warning"].hide();
    },
    get_user_info() {
      let self = this;
      let api = "/user/me";
      this.access_token = localStorage.getItem("access_token");
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          self.userinfo = response.data;
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status == 422) {
              localStorage.clear();
              location.replace("/");
            }
          }
        });
    },
    toComponent(c_name) {
      let userinfo = this.userinfo;
      this.$router.push({
        name: c_name,
        params: { userinfo },
      });
    },
    get_project_url(id) {
      let self = this;
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/" + id + "/url";
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          window.open(response.data, "_blank").focus();
        })
        .catch(function (error) {
          if (error.response) {
            self.status_code = error.response.status;
            self.$refs["errorModal"].show();
          }
        });
    },
  },
};
</script>

<style>
tr {
  vertical-align: middle;
}
</style>